if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData; 
// console.log(formData);
      console.log('routes.cart_add_url', routes.cart_add_url);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          
          if (response.status) {

            console.log('response.status', response.status);

            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          // CUstom code START
           ensureProductsInCart_productformjs(40355229073457, 40532562051121);
          // CUstom code END

        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  });
}

waitForElm('.klaviyo-bis-trigger').then((elm) => {
  const prodForm = document.querySelector(".product-form");
  prodForm.before(elm);
});

const prodAccordions = document.querySelectorAll(".product__accordion");

if (prodAccordions) {
  prodAccordions[0].children[0].setAttribute("open", "open");
  prodAccordions[1].children[0].setAttribute("open", "open");
  prodAccordions[2].children[0].setAttribute("open", "open");
}












// ##################################### AUTO ADD PRDOCT GIF#########################




function ensureProductsInCart_productformjs(giftId1, giftId2) {
  $.getJSON('/cart.js', function (cart) {
    const giftIds = [giftId1, giftId2];
    const giftsInCart = cart.items.filter(item => giftIds.includes(item.id));
    const nonGiftItems = cart.items.filter(item => !giftIds.includes(item.id));

    // 🧩 CASE 1: Only gifts in cart → remove by key
    if (nonGiftItems.length === 0 && giftsInCart.length > 0) {
      console.log("❌ Only gifts in cart — removing by key...");

      giftsInCart.forEach(gift => {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: JSON.stringify({ id: gift.key, quantity: 0 }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            console.log(`🗑️ Removed gift: ${gift.title} (key: ${gift.key})`);
            refreshCartDrawer_productformjs();
          },
          error: function (xhr, status, error) {
            console.error('❌ Error removing gift:', gift.title, error);
          }
        });
      });
      return;
    }

    // 🧩 CASE 2: Regular items exist → ensure both gifts are in cart
    const productIdsInCart = cart.items.map(item => item.id);
    const toAdd = [];

    if (nonGiftItems.length > 0) {
      if (!productIdsInCart.includes(giftId1)) {
        toAdd.push({ id: giftId1, quantity: 1 });
      }
      if (!productIdsInCart.includes(giftId2)) {
        toAdd.push({ id: giftId2, quantity: 1 });
      }

      if (toAdd.length === 0) {
        console.log('✅ Both gifts already in cart');
        return;
      }

      console.log("🎁 Adding missing gifts:", toAdd);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: toAdd }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
          console.log('✅ Added missing gifts to cart:', toAdd);
          refreshCartDrawer_productformjs();
        },
        error: function (xhr, status, error) {
          console.error('❌ Error adding gifts:', status, error);
        }
      });
    }
  });
}



function refreshCartDrawer_productformjs() {
   var currency =  $("body").attr("data-bodycurrency_symbol");
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cartData) {
      console.log('🛒 Cart refreshed:', cartData);

      var sell_availeble = '';
      var htmlprod = '';
      var size_html = '';
      var table_start = '<div class="drawer__cart-items-wrapper"></div><table class="cart-items" role="table"><thead role="rowgroup"><tr role="row"><th id="CartDrawer-ColumnProductImage" role="columnheader"><span class="visually-hidden">Product image</span></th><th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">Product</th><th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">Total</th><th id="CartDrawer-ColumnQuantity" role="columnheader"><span class="visually-hidden">Quantity</span></th></tr></thead><tbody role="rowgroup">';
      var table_end = '</tbody></table></div>';

      $.each(cartData.items, function (index, item) {
        index++;
        sell_availeble = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';
        size_html = item.variant_title ? '<dl><div class="product-option"><dt>Size: </dt><dd>' + item.variant_title + '</dd></div></dl>' : '';

        htmlprod += '<tr id="CartDrawer-Item-' + index + '" class="cart-item" role="row">' +
          '<td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">' +
          '<a href="' + item.url + '" class="cart-item__link" tabindex="-1" aria-hidden="true"></a>' +
          '<img class="cart-item__image" src="' + item.image + '" alt="' + item.product_title + '" loading="lazy" width="150" height="184"></td>' +
          '<td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">' +
          '<a href="' + item.url + '" class="cart-item__name h4 break">' + item.product_title + '</a>' +
          '<div class="product-option">' +currency + ' '+ parseFloat(item.final_price / 100).toFixed(2) + '</div>' +
          size_html + '<p class="product-option">' + sell_availeble + '</p></td>' +
          '<td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">' +
          '<div class="cart-item__price-wrapper"><span class="price price--end">' +currency + ' '+ parseFloat((item.quantity) * (item.final_price / 100)).toFixed(2) + '</span></div></td>' +
          '<td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">' +
          '<div class="cart-item__quantity-wrapper"><quantity-input class="quantity">' +
          '<input class="quantity__input" type="number" name="updates[]" value="' + item.quantity + '" min="0" aria-label="Quantity for ' + item.product_title + '" id="Drawer-quantity-' + index + '" data-index="' + index + '">' +
          '</quantity-input></div></td></tr>';
      });

      var finalHtml = table_start + htmlprod + table_end;
      var isCartEmpty = $(".drawer__inner-empty").length;

      if (isCartEmpty > 0) {
        $('#CartDrawer-CartItems').html(finalHtml);
        $(".drawer__inner-empty").remove();
        $("cart-drawer").removeClass("is-empty").addClass("active");
        $("cart-drawer-items").removeClass("is-empty");
        console.log("🆕 Empty cart filled");
      } else {
        console.log("🔄 Updated cart");
        $('.cart-items tbody').html(htmlprod);
        $(".drawer__inner-empty").remove();
        $("cart-drawer").removeClass("is-empty").addClass("active");
        $("cart-drawer-items").removeClass("is-empty");
      }

      $(".cart-drawer__footer .totals__subtotal-value").text(currency + ' ' + parseFloat(cartData.total_price / 100).toFixed(2));
      $(".drawer__header .items-count").text(cartData.item_count + ' items');
      $('.cart-count-bubble span:first').text(cartData.item_count);
      $(".add_btn .loading-overlay__spinner").addClass("hidden");
      $('#CartDrawer-Checkout').removeAttr('disabled');
    },
    error: function (xhr, status, error) {
      console.error('Error fetching cart data:', status, error);
      $(".add_btn .loading-overlay__spinner").addClass("hidden");
    }
  });
}
